/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Select,
  Button,
  Checkbox,
  Spin,
  message,
} from "antd";
import BottomButton from "./BottomButton";
import Heading from "./Heading";
import { capitaliseWithHyphen } from "../../utils";
import { dateFormat_dmy, timeFormater } from "../../utils";
import AutoCompleteAddress from "../FirstMile/CrediteBooking/AutoCompleteAddress";
import PinCodeValidator from "../../components/PincodeValidator";
import { getPremiseId } from "../../utils/worker";

import API from "../../api";
import urls from "../../api/urls";
import moment from "moment";
const { PERSONAL_DETAILS } = urls;
const premiseId = getPremiseId().split("Bearer ")[1];

const PersonalDetails = ({ handleStepsChange, goBackStep }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [marriageStatus, setMarriageStatus] = useState("married");
  const [personalDetail, setPersonalDetail] = useState({});

  useEffect(() => {
    getPersonalDetails();
  }, []);

  const getPersonalDetails = async () => {
    setLoading(true);
    let response = await API.Api(
      PERSONAL_DETAILS + "/" + premiseId
    ).getWithPremiseHeader();

    if (response?.status) {
      setLoading(false);

      let data = response?.response?.data;
      setPersonalDetail(data);
      form.setFieldsValue({
        educationalQualification: data?.educationalQualification,
        emailID: data?.emailID,
        dateOfBirth: moment(data?.dateOfBirth, dateFormat_dmy),
        marriageDate: moment(data?.marriageDate, dateFormat_dmy),
        marriageStatus: data?.marriageStatus,
        name: data?.name,
        personalAdressLine1: data?.personalAdressLine1,
        personalAdressLine2: data?.personalAdressLine2,
        pincode: data?.pincode,
        primaryPhoneNo: data?.primaryPhoneNo,
        residentalAddress1: data?.residentalAddress1,
        residentalAddress2: data?.residentalAddress2,
        residentalPincode: data?.residentalPincode,
        secondaryPhoneNo: data?.secondaryPhoneNo,
      });
      setMarriageStatus(data?.marriageStatus);
    } else {
      setLoading(false);
    }
  };

  const onPersonalDetailsFinish = async (val) => {
    let response = await API.Api(PERSONAL_DETAILS).postWithPrmiseHeader({
      ...val,
      dateOfBirth: val.dateOfBirth
        ? moment(val.dateOfBirth).format(dateFormat_dmy)
        : null,
      marriageDate: val.marriageDate
        ? moment(val.marriageDate).format(dateFormat_dmy)
        : null,
    });
    if (response?.status) {
      message.success(
        response?.response?.data?.message ||
          "Personal details added successffully."
      );
      handleStepsChange();
    } else {
      message.error(
        response?.response?.data?.message || "Can't update personal details."
      );
    }
  };

  const checkboxHandle = (e) => {
    let formData = form.getFieldsValue();
    if (e.target.checked) {
      form.setFieldsValue({
        residentalPincode: formData?.pincode,
        residentalAddress2: formData?.personalAdressLine2,
        residentalAddress1: formData?.personalAdressLine1,
      });
    } else {
      form.setFieldsValue({
        residentalPincode: "",
        residentalAddress2: "",
        residentalAddress1: "",
      });
    }
  };

  return (
    <div className="cp-detail-wrapper">
      <Spin spinning={loading}>
        <Form
          className="global-form profile-container-form"
          layout={"vertical"}
          onFinish={onPersonalDetailsFinish}
          form={form}
        >
          <Row gutter={24} className="global-form-row">
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please enter name",
                  },
                ]}
              >
                <Input className="input-field-style" placeholder="Enter name" />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Contact no"
                name="primaryPhoneNo"
                rules={[
                  {
                    required: true,
                    message: "Please enter contact no.",
                  },
                ]}
              >
                <Input
                  className="input-field-style"
                  placeholder="Enter contact no."
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 10) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Alternate contact no"
                name="secondaryPhoneNo"
                rules={[
                  {
                    required: false,
                    message: "Please enter alternate contact no.",
                  },
                ]}
              >
                <Input
                  className="input-field-style"
                  placeholder="Enter alternate contact no."
                  onKeyPress={(e) => {
                    if (/[^0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                    if (e.target.value.length >= 10) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="E-mail ID"
                name="emailID"
                rules={[
                  {
                    required: true,
                    message: "Please enter E-mail ID",
                  },
                ]}
              >
                <Input
                  className="input-field-style"
                  placeholder="Enter E-mail ID"
                />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="DOB"
                name="dateOfBirth"
                rules={[
                  {
                    required: true,
                    message: "Please enter DOB",
                  },
                ]}
              >
                <DatePicker
                  className="input-field-style"
                  format={dateFormat_dmy}
                  placeholder="Select DOB"
                  disabledDate={(current) => {
                    return current && current > moment().endOf("day");
                  }}
                />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Educational qualification"
                name="educationalQualification"
                rules={[
                  {
                    required: false,
                    message: "Please enter educational qualification",
                  },
                ]}
              >
                <Input
                  className="input-field-style"
                  placeholder="Enter educational qualification"
                />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Marriage status"
                name="marriageStatus"
                rules={[
                  {
                    required: false,
                    message: "Please enter marriage status",
                  },
                ]}
              >
                <Select
                  className="input-field-style"
                  placeholder="Select marriage status"
                  defaultValue="Married"
                  options={[
                    { value: "married", label: "Married" },
                    { value: "single", label: "Single" },
                  ]}
                  onChange={(e) => setMarriageStatus(e)}
                />
              </Form.Item>
            </Col>
            {marriageStatus === "married" ? (
              <Col md={12} lg={12} xl={12} sm={24} xs={24}>
                <Form.Item
                  label="Marriage date"
                  name="marriageDate"
                  rules={[
                    {
                      required: false,
                      message: "Please enter marriage date",
                    },
                  ]}
                >
                  <DatePicker
                    className="input-field-style"
                    format={dateFormat_dmy}
                    placeholder="Select marriage date"
                    disabledDate={(current) => {
                      return current && current > moment().endOf("day");
                    }}
                  />
                </Form.Item>
              </Col>
            ) : null}
          </Row>

          <Heading title={"Permanent Address"} />
          <Row gutter={24} className="global-form-row">
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              {/* <Form.Item
                label="Permanent address line 1"
                name="personalAdressLine1"
                rules={[
                  {
                    required: true,
                    message: "Please enter residential address line 1",
                  },
                ]}
              >
                <Input
                  className="input-field-style"
                  placeholder="Enter residential address line 1"
                />
              </Form.Item> */}
              <AutoCompleteAddress
                form={form}
                returnAddress={false}
                alertData={null}
                fieldName="personalAdressLine1"
                label="Permanent address line 1"
                rules={[
                  {
                    required: true,
                    message: "Enter address line 1",
                  },
                ]}
              />
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Permanent address line 2"
                name="personalAdressLine2"
                rules={[
                  {
                    required: false,
                    message: "Please enter residential address line 2",
                  },
                ]}
              >
                <Input
                  className="input-field-style"
                  placeholder="Enter house no, building, street"
                />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <PinCodeValidator
                formName={"pincode"}
                value={personalDetail?.pincode}
              />
            </Col>
          </Row>
          <Heading title={"Residential Address"} />
          <Checkbox onChange={checkboxHandle} className="mb-1">
            <b>Same as personal address</b>
          </Checkbox>
          <Row gutter={24} className="global-form-row">
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              {/* <Form.Item
                label="Residential address line 1"
                name="residentalAddress1"
                rules={[
                  {
                    required: true,
                    message: "Please enter residential address line 1",
                  },
                ]}
              >
                <Input
                  className="input-field-style"
                  placeholder="Enter residential address line 1"
                />
              </Form.Item> */}
              <AutoCompleteAddress
                form={form}
                returnAddress={false}
                alertData={null}
                fieldName="residentalAddress1"
                label="Residential address line 1"
                rules={[
                  {
                    required: true,
                    message: "Enter residential address line 1",
                  },
                ]}
              />
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <Form.Item
                label="Residential address line 2"
                name="residentalAddress2"
                rules={[
                  {
                    required: false,
                    message: "Please enter residential address line 2",
                  },
                ]}
              >
                <Input
                  className="input-field-style"
                  placeholder="Enter house no, building, street"
                />
              </Form.Item>
            </Col>
            <Col md={12} lg={12} xl={12} sm={24} xs={24}>
              <PinCodeValidator
                formName={"residentalPincode"}
                value={personalDetail?.residentalPincode}
              />
            </Col>
          </Row>
          <hr
            className="divider"
            style={{ marginTop: "20px", marginBottom: "20px" }}
          />
          <Row
            gutter={12}
            className="mt-2"
            justify={"end"}
            style={{ flex: "auto" }}
          >
            <Col>
              <Button className="cancel-btn" onClick={goBackStep}>
                BACK
              </Button>
            </Col>
            <Col>
              <Form.Item>
                <Button className="save-btn" htmlType="submit">
                  SAVE & CONTINUE
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default PersonalDetails;
